import pipe from 'lodash/fp/pipe';
import _filter from 'lodash/fp/filter';
import _last from 'lodash/fp/last';
import _get from 'lodash/fp/get';
import _getOr from 'lodash/fp/getOr';
import _maxBy from 'lodash/fp/maxBy';

export const formatMileage = (mileage = 0) =>
  mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const getLastServiceDate = pipe(
  _filter(
    ({ isService, serviceName }) => isService || serviceName.match(/mot/i),
  ),
  _last,
  _get('expectedDate'),
);

export const getPlanMonths = pipe(
  _maxBy('monthDue'),
  _get('monthDue'),
);

export const getCustomerEmail = _get('Customer.User.email');

export const isQuoteEmailSent = _getOr(false, 'PlanMeta.isQuoteEmailed');
